import { ProfilerQuestion } from "data/slices/surveyprofiler/interface";

import {
  ProfilerQuestionItemProps,
  ProfilerSetProps,
} from "../../widgets/dashboard/surveyprofiler/interface";

/**
 * Maps survey profiler questions to the format expected by the UI
 */
export const surveyProfilerMapper = (
  questions: ProfilerQuestion[],
  completionStatus: string,
  isError: boolean = false,
): ProfilerSetProps => {
  const hasQuestions = !isError && questions && questions.length > 0;

  const mappedQuestions: ProfilerQuestionItemProps[] = [];
  if (hasQuestions) {
    questions.forEach((question) => {
      mappedQuestions.push({
        id: question.id,
        questionText: question.questionText,
        questionType: question.questionType,
        options:
          question.options?.map((option) => ({
            id: option.id,
            text: option.optionText,
            value: option.value,
          })) || [],
        answer: question.answer || "",
        required: question.required,
      });
    });
  }

  return {
    questions: mappedQuestions,
    completionStatus,
    hasQuestions,
  };
};

/**
 * Maps the survey profiler API response to category items with status and question text
 */
export const surveyProfilerCategoryMapper = (apiResponse): any[] => {
  if (!apiResponse || !Array.isArray(apiResponse)) {
    return [];
  }

  return apiResponse.map((category) => {
    // Determine status based on questions answered
    let status = "New";
    if (category.totalQuestions === 0) {
      status = ""; // No questions case
    } else if (category.questionsAnswered === category.totalQuestions) {
      status = "Completed"; // All questions answered
    } else if (category.questionsAnswered > 0) {
      status = "Started"; // Some but not all questions answered
    }

    // Create question text based on completion status
    let questionText = "";
    if (category.totalQuestions === 0) {
      questionText = "No Questions";
    } else if (category.questionsAnswered === category.totalQuestions) {
      questionText = "No Questions";
    } else {
      const remaining = category.totalQuestions - category.questionsAnswered;
      questionText = `${remaining} Remaining`;
    }

    return {
      ...category,
      status,
      questionText,
    };
  });
};

/**
 * Prepares profiler submission data
 */
export const prepareProfilerSubmission = (
  questions: ProfilerQuestionItemProps[],
) => {
  return questions.map((question) => ({
    questionId: question.id,
    answer: question.answer || "",
  }));
};
